import { c as create_ssr_component, b as add_attribute, v as validate_component } from "../../../../chunks/ssr.js";
import { E as EditorToolbar_1 } from "../../../../chunks/PlainText.js";
import { t as toDateString } from "../../../../chunks/util.js";
import { R as RecipientsSelector, P as Post } from "../../../../chunks/Post.js";
import "../../../../chunks/client.js";
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let bio;
  let { data } = $$props;
  let is_public = false, recipients = [], editable = true, title = "", content = "", created_at = toDateString();
  if ($$props.data === void 0 && $$bindings.data && data !== void 0)
    $$bindings.data(data);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    data.currentUser;
    bio = data.bio;
    $$rendered = `${$$result.head += `<!-- HEAD_svelte-1h6b5sm_START -->${$$result.title = `<title>New post</title>`, ""}<link rel="icon" type="image/png" sizes="300x300"${add_attribute("href", bio.avatar, 0)}><link rel="apple-touch-icon" sizes="300x300"${add_attribute("href", bio.avatar, 0)}><!-- HEAD_svelte-1h6b5sm_END -->`, ""} ${`${validate_component(EditorToolbar_1, "EditorToolbar").$$render(
      $$result,
      {
        confirmLabel: is_public ? "Publish" : recipients.length > 0 ? "Send" : "Save",
        canConfirm: !!title
      },
      {},
      {}
    )}`}  <div class="pt-8 sm:pt-16"></div> ${validate_component(RecipientsSelector, "RecipientsSelector").$$render(
      $$result,
      { editable, is_public, recipients },
      {
        is_public: ($$value) => {
          is_public = $$value;
          $$settled = false;
        },
        recipients: ($$value) => {
          recipients = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${validate_component(Post, "Post").$$render(
      $$result,
      { editable, title, content, created_at },
      {
        title: ($$value) => {
          title = $$value;
          $$settled = false;
        },
        content: ($$value) => {
          content = $$value;
          $$settled = false;
        },
        created_at: ($$value) => {
          created_at = $$value;
          $$settled = false;
        }
      },
      {}
    )} `;
  } while (!$$settled);
  return $$rendered;
});
export {
  Page as default
};
